import { useDeleteDocumentMutation } from "@common/api/documents"
import { handleError } from "@common/utils"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DeleteDialog } from "@/components/layout/list-table-menu"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute(
  "/_layout/airworthiness-directives/delete/$documentId",
)({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "document:delete", "/"),
  component: DeleteDirectiveDialog,
})

function DeleteDirectiveDialog(): React.ReactElement {
  const { documentId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const remove = useDeleteDocumentMutation()

  const close = () =>
    navigate({ to: "/airworthiness-directives", search: true })

  return (
    <DeleteDialog
      noun="airworthiness directive"
      pending={remove.isPending}
      onCancel={close}
      onConfirm={() =>
        remove.mutate(
          { document_id: documentId },
          {
            onSuccess: () => {
              showToast(
                "Deleted",
                "Airworthiness directive deleted.",
                "success",
              )
              close()
            },
            onError: (error) => handleError(error, showToast),
          },
        )
      }
    />
  )
}
